import React from 'react';

const NoMatch = () => {
  return (
    <div className="noMatch">
      <i className="far fa-frown" />
      <h2>404</h2>
      <h3>Page not found</h3>
      <p>Page you are looking for does not exist</p>
    </div>
  );
};

export default NoMatch;



// WEBPACK FOOTER //
// ./src/components/NoMatch.js